import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, take, distinctUntilChanged } from 'rxjs/operators';
import { RequestCriteria } from '../model/request-criteria';

@Injectable()
export class DataOptionsConnectorService implements OnDestroy {

  private filtersSubject = new BehaviorSubject<RequestCriteria | null>(null);
  private currentFiltersSub$ = new BehaviorSubject<RequestCriteria | null>(null);
  private activeFiltersNullable$ = this.filtersSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(null);
  private cancelSubject = new Subject<void>();
  activeFilters$ = this.filtersSubject.asObservable().pipe(filter(filters => filters != null));
  currentFilters$ = this.currentFiltersSub$.asObservable().pipe(filter(filters => filters != null), distinctUntilChanged());
  loading$ = this.loadingSubject.asObservable().pipe(distinctUntilChanged());
  cancel$ = this.cancelSubject.asObservable();

  // zmienia strumień aktualnie wybrane filtry
  updateFilters(filters: RequestCriteria): void {
    this.currentFiltersSub$.next(filters);
  }

  // zwraca aktualnie wybrane filtry
  getCurrentFilters(): Observable<RequestCriteria> {
    return this.currentFilters$;
  }

  // aktywuje aktualnie wybrane filtry
  activateFilters(): void {
    this.filtersSubject.next(this.currentFiltersSub$.value);
  }

  // czyści aktywne i wybrane filtry (w tym filtry kolumnowe) - używane przy przełączeniu
  // trybu, żeby stan z poprzedniego trybu nie wyciekał do żądania w nowym
  resetFilters(): void {
    this.currentFiltersSub$.next(null);
    this.filtersSubject.next(null);
    this.clearColumnFilterValues();
  }

  // zwraca aktywne filtry ostatni stan
  getActiveFilters(): Observable<RequestCriteria> {
    return this.activeFiltersNullable$.pipe(take(1));
  }

  // zwraca aktywne filtry strumień
  getFilters(): Observable<RequestCriteria> {
    return this.activeFiltersNullable$;
  }

  updateLoading(loading: boolean): void {
    this.loadingSubject.next(loading);
  }

  cancel(): void {
    this.cancelSubject.next();
  }

  getActiveFiltersValue(): RequestCriteria {
    return this.filtersSubject.value;
  }

  private columnFilterValues: { [name: string]: any } = {};

  setColumnFilterValue(name: string, value: any): void {
    this.columnFilterValues[name] = value;
  }

  getColumnFilterValue(name: string): any {
    return this.columnFilterValues[name] ?? null;
  }

  clearColumnFilterValues(): void {
    this.columnFilterValues = {};
  }

  ngOnDestroy(): void {
    this.filtersSubject.complete();
  }
}
